import api from './api'

export const balanceSheetService = {
  get: async () => {
    const response = await api.get('/api/financial/balance-sheet')
    return response.data
  },

  createItem: async (payload) => {
    const response = await api.post('/api/financial/balance-sheet/items', payload)
    return response.data
  },

  updateItem: async (id, payload) => {
    const response = await api.put(`/api/financial/balance-sheet/items/${id}`, payload)
    return response.data
  },

  deactivateItem: async (id) => {
    const response = await api.delete(`/api/financial/balance-sheet/items/${id}`)
    return response.data
  }
}
